import React, { useEffect, useState } from 'react';
import SchematicsModal from './schematics';
import VideosModal from './videos';
import ProcessInfoModal from './processInfo';
// import diagram from "../../../../assets/image-empty1.PNG";

const CreateProcedurePrev = ({ procedure }) => {
  const [procedureDetails, setProcedurDetails] = useState('');

  useEffect(() => {
    setProcedurDetails(procedure);
  }, [procedure]);

  return (
    <>
      <div className="procedure-prev-heading  w-[83vw] h-[80vh] overflow-auto ">
        <p className="text-base font-medium">Procedure Preview </p>
        <p className="text-base text-sm">
          Version {procedureDetails?.version ?? 'Untitled version'}
        </p>

        <div className="w-[100%] ">
          <div className="p-6">
            {/* Table of Contents Section */}
            <section id="table-of-contents" className="mb-4">
              <h1 className="text-3xl font-bold mb-4">Table of Content</h1>
              <h2 className="text-1xl font-bold mb-4">Author</h2>

              <ul className="list-disc list-inside">
                <li>
                  <a
                    href="#schematics"
                    className="text-blue-500 hover:underline"
                  >
                    {procedureDetails?.author ?? 'Untitled author'}
                  </a>
                </li>
              </ul>
              <h2 className="text-1xl font-bold mb-4">Edited date</h2>

              <ul className="list-disc list-inside">
                <li>
                  <a
                    href="#schematics"
                    className="text-blue-500 hover:underline"
                  >
                    {procedureDetails?.publishedAt ?? 'Untitled Publish date'}
                  </a>
                </li>
              </ul>
              <h2 className="text-1xl font-bold mb-4">Safety Notes</h2>

              <ul className="list-disc list-inside">
                <li>
                  <a
                    href="#schematics"
                    className="text-blue-500 hover:underline"
                  >
                    {procedureDetails?.procedureSafetyNote?.title ??
                      'Untitled Safety Note'}
                  </a>
                </li>
              </ul>

              <h2 className="text-1xl font-bold mb-4">Steps and Decisions</h2>

              <ul className="list-disc list-inside">
                {procedureDetails?.proc?.map(item =>
                  item?.steps ? (
                    <li>
                      <a
                        href="#schematics"
                        className="text-blue-500 hover:underline"
                      >
                        {item?.steps?.title || 'Untitled Step'}
                      </a>
                    </li>
                  ) : (
                    <li>
                      <a
                        href="#schematics"
                        className="text-blue-500 hover:underline"
                      >
                        {item?.decisions?.title || 'Untitled Decision'}
                      </a>
                    </li>
                  )
                )}
              </ul>
            </section>

            {/* Schematics Section */}
            <SchematicsModal procedure={procedureDetails} />

            {/* Videos Section */}
            <VideosModal procedure={procedureDetails} />

            {/* Process Info Section */}
            <section id="process-info">
              <h2 className="text-2xl font-bold mb-3">Process Info</h2>
              <ProcessInfoModal procedure={procedureDetails} />
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateProcedurePrev;
